module.exports = __webpack_public_path__ + "static/media/shoot_1.7b509b25.gif";